var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.iconName,{tag:"component",staticClass:"anx-icon",attrs:{"width":_vm.width,"height":_vm.height,"margin":_vm.margin,"title":_vm.title}})}
var staticRenderFns = []

export { render, staticRenderFns }